module.exports = __webpack_public_path__ + "img/cz-partners-idnes.39389ca0.png";